/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCustomerFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createUpdateCustomerResponseFromDiscriminatorValue, serializeUpdateCustomerRequest, serializeUpdateCustomerResponse, type Customer, type ErrorResponse, type InternalErrorResponse, type UpdateCustomerRequest, type UpdateCustomerResponse } from '../../../models/index.js';
// @ts-ignore
import { ActivateRequestBuilderRequestsMetadata, type ActivateRequestBuilder } from './activate/index.js';
// @ts-ignore
import { DeactivateRequestBuilderRequestsMetadata, type DeactivateRequestBuilder } from './deactivate/index.js';
// @ts-ignore
import { NotesRequestBuilderNavigationMetadata, NotesRequestBuilderRequestsMetadata, type NotesRequestBuilder } from './notes/index.js';
// @ts-ignore
import { SalesrepRequestBuilderRequestsMetadata, type SalesrepRequestBuilder } from './salesrep/index.js';
// @ts-ignore
import { type VendorsRequestBuilder, VendorsRequestBuilderNavigationMetadata, VendorsRequestBuilderRequestsMetadata } from './vendors/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/customers/{customerNumber}
 */
export interface WithCustomerNumberItemRequestBuilder extends BaseRequestBuilder<WithCustomerNumberItemRequestBuilder> {
    /**
     * The activate property
     */
    get activate(): ActivateRequestBuilder;
    /**
     * The deactivate property
     */
    get deactivate(): DeactivateRequestBuilder;
    /**
     * The notes property
     */
    get notes(): NotesRequestBuilder;
    /**
     * The salesrep property
     */
    get salesrep(): SalesrepRequestBuilder;
    /**
     * The vendors property
     */
    get vendors(): VendorsRequestBuilder;
    /**
     * Delete a Customer by CustomerNumber
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Get a Customer by CustomerNumber
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Customer>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Customer | undefined>;
    /**
     * Update an existing Customer by CustomerNumber
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<UpdateCustomerResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: UpdateCustomerRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<UpdateCustomerResponse | undefined>;
    /**
     * Delete a Customer by CustomerNumber
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Get a Customer by CustomerNumber
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Update an existing Customer by CustomerNumber
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: UpdateCustomerRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithCustomerNumberItemRequestBuilderUriTemplate = "{+baseurl}/api/customers/{customerNumber}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithCustomerNumberItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithCustomerNumberItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    activate: {
        requestsMetadata: ActivateRequestBuilderRequestsMetadata,
    },
    deactivate: {
        requestsMetadata: DeactivateRequestBuilderRequestsMetadata,
    },
    notes: {
        requestsMetadata: NotesRequestBuilderRequestsMetadata,
        navigationMetadata: NotesRequestBuilderNavigationMetadata,
    },
    salesrep: {
        requestsMetadata: SalesrepRequestBuilderRequestsMetadata,
    },
    vendors: {
        requestsMetadata: VendorsRequestBuilderRequestsMetadata,
        navigationMetadata: VendorsRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithCustomerNumberItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithCustomerNumberItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
    get: {
        uriTemplate: WithCustomerNumberItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCustomerFromDiscriminatorValue,
    },
    post: {
        uriTemplate: WithCustomerNumberItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createUpdateCustomerResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateCustomerRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
